<template>
  <div class="main">
    <top-nav></top-nav>
    <div class="formationContent">

      <div class="overview">
        <div class="crumb">首页 / 体育资讯</div>
        <!--        <div class="overviewContent">-->
        <!--          <div class="leftBox">-->
        <!--            <el-carousel height="710px" indicator-position="outside">-->
        <!--              <el-carousel-item v-for="item in bannerList" :key="item.id">-->
        <!--                <div class="carousel_con">-->
        <!--                  <img :src="fileUrl + item.fileUrl"/>-->
        <!--&lt;!&ndash;                  <div class="carousel_block">全民健身“动”起来</div>&ndash;&gt;-->
        <!--                </div>-->
        <!--              </el-carousel-item>-->
        <!--            </el-carousel>-->
        <!--          </div>-->
        <!--          <div class="rightBox">-->
        <!--            <div class="itemBox">-->
        <!--              <img :src="bannerList.length>0 && fileUrl + bannerList[0].fileUrl"/>-->
        <!--&lt;!&ndash;              <div class="carousel_block">记大连体校开展反兴奋剂宣教活动</div>&ndash;&gt;-->
        <!--            </div>-->
        <!--            <div class="itemBox">-->
        <!--              <img :src="bannerList.length>0 && fileUrl + bannerList[1].fileUrl"/>-->
        <!--&lt;!&ndash;              <div class="carousel_block">以球会友 燃情逐梦</div>&ndash;&gt;-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div class="categoryList">
        <el-tabs v-model="activeName" @tab-click="tabChange">
          <el-tab-pane v-for="(item,index) in tabList" :key="'tab'+index" :label="item.label"
                       :name="item.value"></el-tab-pane>

        </el-tabs>
        <div class="categoryBar">
          <ul>
            <li v-for="(item,index) in categoryList" :key="'category'+index" @click="carouselClick(item)">
              <div class="category_div">
                <img :src="fileUrl+item.imageUrl" />
                <div class="div_right">
                  <div class="category_top">
                    <p class="li_title text_overflow">{{ item.title }}</p>
                    <div class="li_info" v-html="item.content"></div>
                  </div>
                  <p class="li_time">{{ item.uploadTime }}</p>
                </div>
              </div>
              <p v-if="(index+1)%2 !==0" class="line_block"></p>
            </li>
          </ul>
          <div v-if="categoryList.length === 0" class="no_data">暂无资讯</div>
          <div class="pagination_con">
            <el-pagination
                :total="total"
                background
                layout="prev, pager, next"
                @current-change="currentChange">
            </el-pagination>
          </div>

        </div>
      </div>


      <!--        <div class="expand"></div>-->
    </div>
    <bot-nav></bot-nav>
  </div>

</template>

<script>
import topNav from "@/components/topNav";
import botNav from "@/components/botNav";
import { FILE_API } from "@/Settings"

export default {
  name: "sportsInformation",
  components: {
    topNav,
    // eslint-disable-next-line vue/no-unused-components
    botNav
  },
  data () {
    return {
      fileUrl: FILE_API,
      activeName: '1',
      tabList: [
        {
          label: '通知公告',
          value: '1'
        },
        {
          label: '媒体聚焦',
          value: '2'
        },
        {
          label: '新闻资讯',
          value: '3'
        },
        // {
        //   label: '图片新闻',
        //   value: '4'
        // },
        {
          label: '赛事活动',
          value: '5'
        }
      ],
      categoryList: [],
      total: 0,
      current: 1,
      bannerList: []
    }
  },
  created () {
    this.getPage()
    // this.bannerAjax()
  },
  methods: {
    carouselClick (item) {
      this.$router.push({
        path: '/sportsDetails',
        query: {
          item: JSON.stringify(item)
        }
      })
    },
    currentChange (e) {
      this.current = e
      this.getPage()
    },
    tabChange (e) {
      this.current = 1
      this.getPage()
    },
    bannerAjax () {
      this.$postAction('gateway/banner/list').then((res) => {
        this.bannerList = res.data
      })
    },
    getPage () {
      this.$postAction('gateway/health-counseling/getPage', {
        "page": {
          "current": this.current,
          "size": 10
        },
        "data": {
          "type": this.activeName,
          "keyword": ""
        }
      }).then((res) => {
        this.categoryList = res.data.records
        this.total = res.data.total
      })
    }
  }
}
</script>

<style scoped>
::v-deep .el-carousel__indicator--horizontal {
  height: 30px !important;
}


.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}


</style>

<style lang="less" scoped>
.formationContent {
  display: flex;
  flex-direction: column;
  padding: 0 100px 0px 100px;
  overflow-y: auto;
  height: 100%;

  .overview {
    //height: 800px;

    .tagTitle {
      width: 64px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      margin-bottom: 30px;
    }

    .overviewContent {
      height: 750px;
      display: flex;

      .leftBox {
        height: 100%;
        width: 60%;
        margin-right: 1%;
      }

      .rightBox {
        height: 710px;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .itemBox {
          height: 350px;
          width: 100%;
          position: relative;

          img {
            width: 100%;
            height: 100%;
          }

        }

        .carousel_block {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 80px;
          background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
          display: flex;
          align-items: center;
          font-size: 28px;
          color: #FFFFFF;
          padding-left: 18px;
        }

      }
    }
  }

  .categoryList {
    //height: 850px;
    min-height: 500px;

    .categoryBar {
      width: 100%;

      ul {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: 0;
        padding: 0;

        li {
          list-style: none;
          width: calc(100% / 2);
          display: flex;
          cursor: pointer;

          .line_block {
            height: 100%;
            width: 1px;
            background-color: rgba(220, 220, 220, 1);
            margin: 0 20px;
          }

          .category_div {
            display: flex;
            align-items: center;
            height: 180px;
            border-bottom: 1px solid rgba(220, 220, 220, 1);
            width: 100%;
            overflow: hidden;

            img {
              width: 200px;
              height: 115px;
              margin-right: 9px;
              object-fit: cover;
            }

            p {
              margin: 0;
              padding: 0;
            }

            .div_right {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              height: 115px;
              flex: 1;
              overflow: hidden;
            }

            .li_title {
              font-weight: 700;
              font-size: 24px;
              color: #333333;
              margin-bottom: 5px;
            }

            &:hover {
              .li_title {
                color: #0058A6;
              }
            }

            ::v-deep .li_info {
              font-size: 16px;
              color: #666666;
              text-align: justify;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              height: 60px;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;

              p {
                margin: 0 !important;
                line-height: 1.8;
              }

              img {
                display: none;
              }
            }

            .li_time {
              font-weight: 400;
              font-size: 14px;
              color: #999999;
            }
          }

        }
      }
    }
  }

}

.carousel_con {
  width: 100%;
  height: 100%;
  position: relative;

  img {
    width: 100%;
    height: 100%;
  }

  .carousel_block {
    height: 99px;
    width: 100%;
    background-color: rgba(233, 233, 234, 0.73);
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 36px;
    color: #333333;
  }
}

.pagination_con {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .el-carousel__button {
  height: 8px;
  width: 55px;
}

::v-deep .el-carousel__indicator.is-active button {
  background-color: rgba(0, 88, 166, 1) !important;
}
</style>
